import { render } from "./MediaItem.vue?vue&type=template&id=40212aed&scoped=true"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"

import "./MediaItem.vue?vue&type=style&index=0&id=40212aed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40212aed"]])

export default __exports__